import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CheckCircle, Home, History } from 'lucide-react'
import { AuthLayout } from '@/components/AuthLayout'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export function PaymentSuccessPage() {
  const { t } = useTranslation(['payments', 'common'])
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [countdown, setCountdown] = useState(10)

  const merchantRef = searchParams.get('ref')

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          navigate('/')
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [navigate])

  return (
    <AuthLayout>
      <Card>
        <CardContent className="py-10 text-center space-y-6">
          <div className="rounded-full bg-emerald-100 p-4 w-fit mx-auto">
            <CheckCircle className="h-12 w-12 text-emerald-600" />
          </div>

          <div>
            <h1 className="text-2xl font-bold text-emerald-600 mb-2">{t('success.title')}</h1>
            <p className="text-muted-foreground">{t('success.message')}</p>
          </div>

          {merchantRef && (
            <div className="bg-muted rounded-lg p-4">
              <p className="text-xs text-muted-foreground mb-1">{t('reference')}</p>
              <p className="font-mono font-medium">{merchantRef}</p>
            </div>
          )}

          <div className="space-y-3">
            <Button className="w-full" onClick={() => navigate('/')}>
              <Home className="h-4 w-4 mr-2" />
              {t('backToHome', { ns: 'common' })}
            </Button>
            <Button variant="outline" className="w-full" onClick={() => navigate('/payments/history')}>
              <History className="h-4 w-4 mr-2" />
              {t('viewPaymentHistory')}
            </Button>
          </div>

          <p className="text-xs text-muted-foreground">
            {t('autoRedirect', { seconds: countdown })}
          </p>
        </CardContent>
      </Card>
    </AuthLayout>
  )
}
